import './_mini-cart-gwp.scss';
import component from './mini-cart-gwp';

export default component;
